var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "a",
    d: "M.59,7H20.41A10.5,10.5,0,0,0,.59,7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    className: "b",
    d: "M10.5,21A10.5,10.5,0,0,0,20.38,14H.62A10.5,10.5,0,0,0,10.5,21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0039a6",
    className: "c",
    d: "M20.41,7H.59A10.45,10.45,0,0,0,0,10.5v0A10.4,10.4,0,0,0,.62,14H20.38A10.4,10.4,0,0,0,21,10.53v0A10.45,10.45,0,0,0,20.41,7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRu);
export default __webpack_public_path__ + "static/media/ru.4521d783c294de232fefffe958278161.svg";
export { ForwardRef as ReactComponent };